import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const IconBookmarkFilled = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 16 16"
    >
      <path
        d="M12.1673 13.7674L8.52828 11.5072C8.20515 11.3065 7.79615 11.3065 7.47303 11.5072L3.83398 13.7674L3.83398 1.91296C3.83398 1.89283 3.842 1.87289 3.85729 1.8577C3.87268 1.8424 3.89421 1.83325 3.91732 1.83325H12.084C12.1071 1.83325 12.1286 1.8424 12.144 1.8577C12.1593 1.87289 12.1673 1.89283 12.1673 1.91296V13.7674Z"
        fill="currentColor"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  ))
);
